document.addEventListener("DOMContentLoaded", function () {
  const mediaGrid = document.querySelector("media-grid");
  let isDragging = false;
  let startX;
  let scrollLeft;

  if (mediaGrid) {
    mediaGrid.addEventListener("mousedown", (e) => {
      isDragging = true;
      startX = e.pageX - mediaGrid.offsetLeft;
      scrollLeft = mediaGrid.scrollLeft;
      mediaGrid.style.cursor = "grabbing";
      e.preventDefault();
    });

    mediaGrid.addEventListener("mouseleave", () => {
      isDragging = false;
      mediaGrid.style.cursor = "grab";
    });

    mediaGrid.addEventListener("mouseup", () => {
      isDragging = false;
      mediaGrid.style.cursor = "grab";
    });

    mediaGrid.addEventListener("mousemove", (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - mediaGrid.offsetLeft;
      const walk = (x - startX) * 2; // 控制滑動速度
      mediaGrid.scrollLeft = scrollLeft - walk;
    });

    console.log("video.js 加載成功！");
  }
});
